module.exports = __webpack_public_path__ + "static/media/Gambia.a56ebd66.png";